import theme from '../../theme';

export const styles = () => ({
  text: {
    ...theme.textStyles['h4'],
    color: theme.colors.text['highEmphasis']
  }
});
